import React from "react";

const ScheduleDemo = () => {
  return (
    <section className="container flex flex-col items-center gap-12 px-8 py-16 mx-auto md:flex-row">
      {/* Left: Form Section */}
      <div className="text-center md:w-1/2 md:text-left">
        <h2 className="text-3xl font-bold text-gray-900">Schedule A Demo</h2>
        <p className="mt-4 text-lg text-gray-700">
          Experience how EzzyDental can streamline your dental practice. Book a live demo with our experts today!
        </p>

        {/* Demo Form */}
        <form className="mt-6 space-y-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <input type="text" placeholder="First Name" className="w-full p-3 border rounded-lg" required />
            <input type="text" placeholder="Last Name" className="w-full p-3 border rounded-lg" required />
          </div>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <input type="email" placeholder="Email" className="w-full p-3 border rounded-lg" required />
            <input type="tel" placeholder="Phone Number" className="w-full p-3 border rounded-lg" required />
          </div>
          <input type="text" placeholder="Practice Name" className="w-full p-3 border rounded-lg" required />
          <select className="w-full p-3 border rounded-lg">
            <option>What is your current practice management software?</option>
            <option>None</option>
            <option>Dentrix</option>
            <option>Eaglesoft</option>
            <option>Open Dental</option>
            <option>Other</option>
          </select>
          <button type="submit" className="w-full px-6 py-3 text-lg text-white transition bg-indigo-600 rounded-lg shadow-md hover:bg-indigo-700">
            Request a Demo
          </button>
        </form>
      </div>

      {/* Right: Image Section */}
      <div className="md:w-1/2">
        <img
          src="/assets/Schedule_A_Demo.webp"
          alt="Schedule a Demo"
          className="w-full rounded-lg shadow-md"
        />
      </div>
    </section>
  );
};

export default ScheduleDemo;
